export default __webpack_public_path__ + "static/cloggedneedlefile-e597d0ef20670ec8c4c40644d91c9256.png";